import { CSSProperties } from "@material-ui/core/styles/withStyles";

export const wrappingContainer: CSSProperties = {
  flex: 1,
  width: "calc(100% - 120px)",
  maxHeight: "calc(100% - 40px)",
  display: "flex",
  paddingTop: 20,
  userSelect: "none",
};

export const fab: CSSProperties = {
  position: "fixed",
  bottom: 24,
  right: 24,
  zIndex: 20,
};

export const styles = {
  wrappingContainer,
  fab,
};
